const buildItemsDepthMap = (flatTree, rootId) => {
  const nodeMap = new Map();
  const childrenMap = new Map();
  childrenMap.set(rootId, []);

  flatTree.forEach((node) => {
    nodeMap.set(node.id, node);
    childrenMap.set(node.id, []);
  });

  flatTree.forEach((node) => {
    const siblings = childrenMap.get(node.parent);
    if (siblings) {
      siblings.push(node.id);
    }
  });

  const itemsDepthMap = new Map();
  const descendantItemIds = new Map();

  // Single DFS post-order pass that computes, for every node: its depth, the
  // deepest descendant depth and folder depth (both relative to the node), and
  // the full set of descendant ids.
  const traverse = (nodeId, depth) => {
    const node = nodeMap.get(nodeId);
    const children = childrenMap.get(nodeId) || [];

    let maxChildDepth = 0;
    // Deepest folder within the subtree, relative to this node (0 when the
    // node itself is a folder). `null` means the subtree has no folder at all.
    let maxFolderChildDepth = node?.droppable ? 0 : null;
    const descendants = new Set();

    children.forEach((childId) => {
      const child = traverse(childId, depth + 1);

      const relativeDepth = 1 + child.maxChildDepth;
      if (relativeDepth > maxChildDepth) maxChildDepth = relativeDepth;

      if (child.maxFolderChildDepth !== null) {
        const relativeFolderDepth = 1 + child.maxFolderChildDepth;
        if (maxFolderChildDepth === null || relativeFolderDepth > maxFolderChildDepth) {
          maxFolderChildDepth = relativeFolderDepth;
        }
      }

      descendants.add(childId);
      child.descendants.forEach((id) => descendants.add(id));
    });

    if (nodeId !== rootId) {
      itemsDepthMap.set(nodeId, { depth, maxChildDepth, maxFolderChildDepth });
    }
    descendantItemIds.set(nodeId, descendants);

    return { maxChildDepth, maxFolderChildDepth, descendants };
  };

  traverse(rootId, 0);

  return { itemsDepthMap, descendantItemIds, nodeMap, childrenMap };
};

export default buildItemsDepthMap;
